import { StatusPill, type PillKind } from "./StatusPill";
import type { Order } from "@/api/orders";

interface FlagDef {
  key: keyof Order["status"];
  label: string;
  kind: PillKind;
}

const FLAGS: FlagDef[] = [
  { key: "is_paid", label: "Bezahlt", kind: "ok" },
  { key: "is_packed", label: "Kommissioniert", kind: "ok" },
  { key: "is_shipped", label: "Versendet", kind: "ok" },
  { key: "is_arrived", label: "Zugestellt", kind: "ok" },
  { key: "is_cancelled", label: "Storniert", kind: "crit" },
  { key: "is_parked", label: "Geparkt", kind: "low" },
];

export function OrderStatusFlags({
  status,
  compact,
}: {
  status: Order["status"];
  compact?: boolean;
}) {
  const active = FLAGS.filter((f) => status[f.key]);
  if (active.length === 0) {
    return <span className="text-xs text-muted">—</span>;
  }
  return (
    <div className="flex flex-wrap gap-1">
      {active.map((f) => (
        <StatusPill key={String(f.key)} kind={f.kind} label={f.label} compact={compact} />
      ))}
    </div>
  );
}
